import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';

function AdminSidebar({ isOpen, callback }) {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = (location.pathname).split("/")[2];
  const currentUser = useSelector((state) => state.data);
  useEffect(() => {
    if (currentUser && currentUser.user_type != "admin" && currentUser.kyc_id == null && pathName && ['addMoney'].includes(pathName)) {
      toast("KYC is pending!");
      navigate('/admin/dashboard');
    }
    if (pathName && ['users', 'kycs', 'notice', 'moneyTransfer', 'pendingRequest', 'verifyTransaction', 'serviceCategories', 'serviceProviders', 'appSettings'].includes(pathName) && currentUser && currentUser.user_type != "admin") {
      navigate('/admin/dashboard');
    }
    if (pathName && ['cashVoucher'].includes(pathName) && currentUser && currentUser._id != "5e09e059db151d0afa79aaa3") {
      navigate('/admin/dashboard');
    }
    if (pathName) {
      callback(false);
    }
  }, [currentUser, pathName]);
  return (
    <nav className={`sidebar sidebar-offcanvas ${isOpen ? "active" : ""}`} id="sidebar">
      <ul className="nav">
        <li className={`nav-item ${pathName === 'dashboard' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/dashboard">
            <i className="ti-shield menu-icon"></i>
            <span className="menu-title">Dashboard</span>
          </Link>
        </li>
        <li className={`nav-item ${pathName === 'addMoney' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/addMoney">
            <i className="ti-money menu-icon"></i>
            <span className="menu-title">Add Money</span>
          </Link>
        </li>
        <li className={`nav-item ${pathName === 'kycVerification' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/kycVerification">
            <i className="ti-id-badge menu-icon"></i>
            <span className="menu-title">KYC Verification</span>
          </Link>
        </li>
        {(currentUser && currentUser._id == "5e09e059db151d0afa79aaa3") && (
          <li className={`nav-item ${pathName === 'cashVoucher' ? 'active' : ''}`}>
            <Link className="nav-link" to="/admin/cashVoucher">
              <i className="ti-ticket menu-icon"></i>
              <span className="menu-title">Cash Voucher</span>
            </Link>
          </li>
        )}
        <li className={`nav-item ${pathName === 'recharge' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/recharge">
            <i className="ti-mobile menu-icon"></i>
            <span className="menu-title">Recharge</span>
          </Link>
        </li>
        <li className={`nav-item ${pathName === 'indianRecharge' ? 'active' : ''}`}>
          <Link className="nav-link" to="/admin/indianRecharge">
            <i className="ti-mobile menu-icon"></i>
            <span className="menu-title">Indian Recharge</span>
          </Link>
        </li>
        {
          currentUser && currentUser.user_type != 'user' && (
            <>
              {
                currentUser?.prabhuMoneyTransfer == true && (
                  <li className={`nav-item ${pathName === 'indoNepalMoneyTransfer' ? 'active' : ''}`}>
                    <Link className="nav-link" to="/admin/indoNepalMoneyTransfer">
                      <i className="ti-location-arrow menu-icon"></i>
                      <span className="menu-title">IndoNepal Money Transfer</span>
                    </Link>
                  </li>
                )
              }
              {
                currentUser?.prabhuCspOnboarding == true && (
                  <li className={`nav-item ${pathName === 'cspIndoNepal' ? 'active' : ''}`}>
                    <Link className="nav-link" to="/admin/cspIndoNepal">
                      <i className="ti-money menu-icon"></i>
                      <span className="menu-title">CSP IndoNepal</span>
                    </Link>
                  </li>
                )
              }
              {
                currentUser?.imeMoneyTransfer == true && (
                  <li className={`nav-item ${pathName === 'imeMoneyTransfer' ? 'active' : ''}`}>
                    <Link className="nav-link" to="/admin/imeMoneyTransfer">
                      <i className="ti-location-arrow menu-icon"></i>
                      <span className="menu-title">IME Money Transfer</span>
                    </Link>
                  </li>
                )
              }
              {
                currentUser?.imeMoneyTransfer == true && (
                  <li className={`nav-item ${pathName === 'imeKycMoneyTransfer' ? 'active' : ''}`}>
                    <Link className="nav-link" to="/admin/imeKycMoneyTransfer">
                      <i className="ti-location-arrow menu-icon"></i>
                      <span className="menu-title">IME Kyc Money Transfer</span>
                    </Link>
                  </li>
                )
              }
              {
                currentUser?.imeCspOnboarding == true && (
                  <li className={`nav-item ${pathName === 'cspIme' ? 'active' : ''}`}>
                    <Link className="nav-link" to="/admin/cspIme">
                      <i className="ti-money menu-icon"></i>
                      <span className="menu-title">CSP IME</span>
                    </Link>
                  </li>
                )
              }
              {
                currentUser?.user_type == "admin" && (
                  <>
                    <li className={`nav-item ${pathName === 'users' ? 'active' : ''}`}>
                      <Link className="nav-link" to="/admin/users">
                        <i className="ti-user menu-icon"></i>
                        <span className="menu-title">User Management</span>
                      </Link>
                    </li>
                    <li className={`nav-item ${pathName === 'kycs' ? 'active' : ''}`}>
                      <Link className="nav-link" to="/admin/kycs">
                        <i className="ti-tablet menu-icon"></i>
                        <span className="menu-title">KYC Management</span>
                      </Link>
                    </li>
                    <li className={`nav-item ${pathName === 'checkIndoNepalTransaction' || pathName === 'checkPayuTransaction' ? 'active' : ''}`}>
                      <a className="nav-link" data-bs-toggle="collapse" href="#ui-basic0" aria-expanded={pathName === 'checkIndoNepalTransaction' || pathName === 'checkPayuTransaction' ? 'true' : 'false'}
                        aria-controls="ui-basic0">
                        <i className="ti-book menu-icon"></i>
                        <span className="menu-title">Transactions</span>
                        <i className="menu-arrow"></i>
                      </a>
                      <div className={`collapse ${pathName === 'checkIndoNepalTransaction' || pathName === 'checkPayuTransaction' ? 'show' : ''}`} id="ui-basic0">
                        <ul className="nav flex-column sub-menu">
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'checkIndoNepalTransaction' ? 'active' : ''}`} to="/admin/checkIndoNepalTransaction">Indo Nepal</Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'checkPayuTransaction' ? 'active' : ''}`} to="/admin/checkPayuTransaction">PayU</Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className={`nav-item ${pathName === 'productCategory' || pathName === 'productSubCategory' || pathName === 'products' || pathName === 'orders' ? 'active' : ''}`}>
                      <a className="nav-link" data-bs-toggle="collapse" href="#ui-basic1" aria-expanded={pathName === 'productCategory' || pathName === 'productSubCategory' || pathName === 'products' || pathName === 'orders' ? 'true' : 'false'}
                        aria-controls="ui-basic1">
                        <i className="ti-book menu-icon"></i>
                        <span className="menu-title">Product Management</span>
                        <i className="menu-arrow"></i>
                      </a>
                      <div className={`collapse ${pathName === 'productCategory' || pathName === 'productSubCategory' || pathName === 'products' || pathName === 'orders' ? 'show' : ''}`} id="ui-basic1">
                        <ul className="nav flex-column sub-menu">
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'productCategory' ? 'active' : ''}`} to="/admin/productCategory">Product Categories</Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'productSubCategory' ? 'active' : ''}`} to="/admin/productSubCategory">Product SubCategories</Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'products' ? 'active' : ''}`} to="/admin/products">Products</Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'orders' ? 'active' : ''}`} to="/admin/orders">Orders</Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className={`nav-item ${pathName === 'lotteryCoupons' || pathName === 'lotteryResults' ? 'active' : ''}`}>
                      <a className="nav-link" data-bs-toggle="collapse" href="#ui-basic2" aria-expanded={pathName === 'lotteryCoupons' || pathName === 'lotteryResults' ? 'true' : 'false'}
                        aria-controls="ui-basic2">
                        <i className="ti-book menu-icon"></i>
                        <span className="menu-title">Lottery Management</span>
                        <i className="menu-arrow"></i>
                      </a>
                      <div className={`collapse ${pathName === 'lotteryCoupons' || pathName === 'lotteryResults' ? 'show' : ''}`} id="ui-basic2">
                        <ul className="nav flex-column sub-menu">
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'lotteryCoupons' ? 'active' : ''}`} to="/admin/lotteryCoupons">Lottery Coupons</Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'lotteryResults' ? 'active' : ''}`} to="/admin/lotteryResults">Lottery Results</Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li className={`nav-item ${pathName === 'notice' ? 'active' : ''}`}>
                      <Link className="nav-link" to="/admin/notice">
                        <i className="ti-notepad menu-icon"></i>
                        <span className="menu-title">Notice</span>
                      </Link>
                    </li>
                    <li className={`nav-item ${pathName === 'moneyTransfer' ? 'active' : ''}`}>
                      <Link className="nav-link" to="/admin/moneyTransfer">
                        <i className="ti-location-arrow menu-icon"></i>
                        <span className="menu-title">Money Transfer</span>
                      </Link>
                    </li>
                    <li className={`nav-item ${pathName === 'pendingRequest' ? 'active' : ''}`}>
                      <Link className="nav-link" to="/admin/pendingRequest">
                        <i className="ti-wallet menu-icon"></i>
                        <span className="menu-title">Pending Requests</span>
                      </Link>
                    </li>
                    <li className={`nav-item ${pathName === 'verifyTransaction' ? 'active' : ''}`}>
                      <Link className="nav-link" to="/admin/verifyTransaction">
                        <i className="ti-wallet menu-icon"></i>
                        <span className="menu-title">Verify Transaction</span>
                      </Link>
                    </li>
                    <li className={`nav-item ${pathName === 'complaint' ? 'active' : ''}`}>
                      <Link className="nav-link" to="/admin/complaint">
                        <i className="ti-wallet menu-icon"></i>
                        <span className="menu-title">Complaint</span>
                      </Link>
                    </li>
                    <li className={`nav-item ${pathName === 'serviceCategories' || pathName === 'serviceProviders' ? 'active' : ''}`}>
                      <a className="nav-link" data-bs-toggle="collapse" href="#ui-basic3" aria-expanded={pathName === 'serviceCategories' || pathName === 'serviceProviders' ? 'true' : 'false'}
                        aria-controls="ui-basic3">
                        <i className="ti-book menu-icon"></i>
                        <span className="menu-title">Service</span>
                        <i className="menu-arrow"></i>
                      </a>
                      <div className={`collapse ${pathName === 'serviceCategories' || pathName === 'serviceProviders' ? 'show' : ''}`} id="ui-basic3">
                        <ul className="nav flex-column sub-menu">
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'serviceCategories' ? 'active' : ''}`} to="/admin/serviceCategories">Categories</Link>
                          </li>
                          <li className="nav-item">
                            <Link className={`nav-link ${pathName === 'serviceProviders' ? 'active' : ''}`} to="/admin/serviceProviders">Providers</Link>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </>
                )
              }
            </>
          )
        }
        <li className={`nav-item ${pathName === 'rechargeReport' || pathName === 'remitanceReport' || pathName === 'imeReport' || pathName === 'remittanceWalletHistory' || pathName === 'rechargeWalletHistory' ? 'active' : ''}`}>
          <a className="nav-link" data-bs-toggle="collapse" href="#ui-basic4" aria-expanded={pathName === 'rechargeReport' || pathName === 'remitanceReport' || pathName === 'imeReport' || pathName === 'remittanceWalletHistory' || pathName === 'rechargeWalletHistory' ? 'true' : 'false'}
            aria-controls="ui-basic4">
            <i className="ti-book menu-icon"></i>
            <span className="menu-title">History</span>
            <i className="menu-arrow"></i>
          </a>
          <div className={`collapse ${pathName === 'rechargeReport' || pathName === 'remitanceReport' || pathName === 'imeReport' || pathName === 'remittanceWalletHistory' || pathName === 'rechargeWalletHistory' ? 'show' : ''}`} id="ui-basic4">
            <ul className="nav flex-column sub-menu">
              <li className="nav-item">
                <Link className={`nav-link ${pathName === 'rechargeReport' ? 'active' : ''}`} to="/admin/rechargeReport">Recharge Report</Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${pathName === 'remitanceReport' ? 'active' : ''}`} to="/admin/remitanceReport">Remitance Report</Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${pathName === 'imeReport' ? 'active' : ''}`} to="/admin/imeReport">IME Report</Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${pathName === 'rechargeWalletHistory' ? 'active' : ''}`} to="/admin/rechargeWalletHistory">WalletHistory(Recharge)</Link>
              </li>
              <li className="nav-item">
                <Link className={`nav-link ${pathName === 'remittanceWalletHistory' ? 'active' : ''}`} to="/admin/remittanceWalletHistory">WalletHistory(Remitance)</Link>
              </li>
            </ul>
          </div>
        </li>
        {/* <li className="nav-item">
          <a className="nav-link" href="pages/forms/basic_elements.html">
            <i className="ti-layout-list-post menu-icon"></i>
            <span className="menu-title">Form elements</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="pages/charts/chartjs.html">
            <i className="ti-pie-chart menu-icon"></i>
            <span className="menu-title">Charts</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="pages/tables/basic-table.html">
            <i className="ti-view-list-alt menu-icon"></i>
            <span className="menu-title">Tables</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="pages/icons/themify.html">
            <i className="ti-star menu-icon"></i>
            <span className="menu-title">Icons</span>
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" data-bs-toggle="collapse" href="#auth" aria-expanded="false" aria-controls="auth">
            <i className="ti-user menu-icon"></i>
            <span className="menu-title">User Pages</span>
            <i className="menu-arrow"></i>
          </a>
          <div className="collapse" id="auth">
            <ul className="nav flex-column sub-menu">
              <li className="nav-item"> <a className="nav-link" href="pages/samples/login.html"> Login </a></li>
              <li className="nav-item"> <a className="nav-link" href="pages/samples/login-2.html"> Login 2 </a></li>
              <li className="nav-item"> <a className="nav-link" href="pages/samples/register.html"> Register </a></li>
              <li className="nav-item"> <a className="nav-link" href="pages/samples/register-2.html"> Register 2 </a></li>
              <li className="nav-item"> <a className="nav-link" href="pages/samples/lock-screen.html"> Lockscreen </a></li>
            </ul>
          </div>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="documentation/documentation.html">
            <i className="ti-write menu-icon"></i>
            <span className="menu-title">Documentation</span>
          </a>
        </li> */}
      </ul>
    </nav>
  );
}

export default AdminSidebar;
